/* Brand Best Sellers nav — show only for mobile returning visitors */
(function () {
  const VISIT_KEY = 'pf_has_visited';
  const SESSION_FLAG = 'pf_visit_session';
  const ACTIVE_CLASS = 'brand-best-sellers-nav--active';
  const MOBILE_MQ = '(max-width: 1000px)';

  let isReturning = false;
  try {
    isReturning = localStorage.getItem(VISIT_KEY) === '1';
    if (!sessionStorage.getItem(SESSION_FLAG)) {
      sessionStorage.setItem(SESSION_FLAG, '1');
      localStorage.setItem(VISIT_KEY, '1');
    }
  } catch (e) {
    isReturning = false;
  }

  function syncVisibility() {
    const mobile = window.matchMedia(MOBILE_MQ).matches;
    document.body.classList.toggle(ACTIVE_CLASS, mobile && isReturning);
  }

  const mq = window.matchMedia(MOBILE_MQ);
  syncVisibility();

  if (mq.addEventListener) {
    mq.addEventListener('change', syncVisibility);
  } else if (mq.addListener) {
    mq.addListener(syncVisibility);
  }
})();
